import apiService from '../utils/apiService';
import { API_CONFIG } from '../utils/constants';

/**
 * Resolved access for the signed-in user.
 *
 * The same endpoint the Portal calls. It returns the user's effective roles,
 * tiers, platforms, route ids, feature flags and permissions after the
 * role-and-tier intersection has already been applied server-side, so callers
 * never have to work that out themselves.
 *
 * @typedef {object} ResolvedAccess
 * @property {string}   userId
 * @property {string[]} permissions
 * @property {string[]} featureFlags
 * @property {string[]} platforms
 * @property {string[]} routeIds
 * @property {string[]} roleNames
 * @property {string[]} tierCodes
 * @property {string=}  defaultLandingPath
 */

const accessService = {
  /** @returns {Promise<ResolvedAccess>} */
  getMe: async () => apiService.get(API_CONFIG.ACCESS.ME),
};

export default accessService;
